import { StackRoutes } from './routes/Stack.Routes'

function App() {
  return (
        <StackRoutes /> 
  );
}

export default App;
